import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { useState } from 'react';
import { useQuery } from 'urql';
import { GET_QUESTIONS_QUERY } from './queries';
import { sorts } from './constants';
import Button from '../../../components/Button';
import CollectionFilters from '../../../components/CollectionFilters';
import ErrorBoundary from '../../../components/ErrorBoundary';
import Paginator from '../../../components/Paginator';
import Question from '../Question';
import Spinner from '../../../components/icons/Spinner';
import css from './Questions.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Questions = function Questions(_ref) {
  var onAskQuestion = _ref.onAskQuestion,
      queryLimit = _ref.queryLimit,
      shopifyId = _ref.shopifyId;

  var _useState = useState(sorts[0]),
      _useState2 = _slicedToArray(_useState, 2),
      sort = _useState2[0],
      setSort = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      pageIndex = _useState4[0],
      setPageIndex = _useState4[1];

  var _useState5 = useState({
    after: null,
    first: queryLimit,
    orderBy: sort.orderBy,
    productShopifyId: shopifyId
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      variables = _useState6[0],
      setVariables = _useState6[1];

  var _useQuery = useQuery({
    query: GET_QUESTIONS_QUERY,
    variables: variables
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      error = _useQuery2$.error,
      fetching = _useQuery2$.fetching;

  if (!data) {
    return /*#__PURE__*/_jsx("div", {
      className: css.root,
      children: /*#__PURE__*/_jsx(Spinner, {})
    });
  }

  var _data$questions = data.questions,
      questions = _data$questions.edges,
      count = _data$questions.totalCount;
  var results = questions && questions.length > 0;
  var lastPageIndex = Math.ceil(count / queryLimit) - 1;

  var goToIndex = function goToIndex(newIndex) {
    var validIndex = newIndex > 0 && newIndex <= lastPageIndex;
    var nextAfter = false;
    var nextPageIndex = newIndex;

    if (validIndex) {
      nextAfter = btoa("arrayconnection:".concat(nextPageIndex * queryLimit - 1));
    }

    setVariables(_objectSpread(_objectSpread({}, variables), {}, {
      after: nextAfter
    }));
    setPageIndex(nextPageIndex);
  };

  var onSortSelect = function onSortSelect(_ref2) {
    var value = _ref2.value;
    var newSort = sorts.find(function (srt) {
      return srt.value === value;
    }) || sorts[0];
    setSort(newSort);
    setVariables(_objectSpread(_objectSpread({}, variables), {}, {
      after: null,
      orderBy: newSort.orderBy
    }));
    setPageIndex(0);
  };

  var noResultsMessage = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      children: "No questions yet. Be the first to\xA0"
    }), /*#__PURE__*/_jsx(Button, {
      className: css.askQuestionBtn,
      linkStyle: true,
      onClick: onAskQuestion,
      children: "ask us!"
    })]
  });

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [results && /*#__PURE__*/_jsx("div", {
      className: css.filters,
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        error: error,
        children: /*#__PURE__*/_jsx(CollectionFilters, {
          clearFilters: function clearFilters() {},
          displaySort: true,
          filtered: false,
          filters: [],
          filterSelect: function filterSelect() {},
          itemsLength: count,
          sort: sort,
          sorts: sorts,
          sortSelect: onSortSelect,
          unpadded: true
        })
      })
    }), fetching && /*#__PURE__*/_jsx(Spinner, {}), /*#__PURE__*/_jsx(ErrorBoundary, {
      error: error,
      children: results && /*#__PURE__*/_jsx("ul", {
        className: css.list,
        children: questions.map(function (_ref3) {
          var question = _ref3.node;
          return /*#__PURE__*/_jsx("li", {
            className: css.item,
            children: /*#__PURE__*/_jsx(Question, _objectSpread({}, question))
          }, question.id);
        })
      })
    }), !fetching && /*#__PURE__*/_jsx(Paginator, {
      lastPageIndex: lastPageIndex,
      noResultsMessage: noResultsMessage,
      onClickLast: function onClickLast() {
        return goToIndex(lastPageIndex);
      },
      onClickNext: function onClickNext() {
        return goToIndex(pageIndex + 1);
      },
      onClickPrevious: function onClickPrevious() {
        return goToIndex(pageIndex - 1);
      },
      pageIndex: pageIndex,
      results: results,
      type: "Questions"
    })]
  });
};

Questions.propTypes = {
  onAskQuestion: PropTypes.func.isRequired,
  queryLimit: PropTypes.number.isRequired,
  shopifyId: PropTypes.number.isRequired
};
export default Questions;